var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedalla(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.9969402%",
    cy: "50.0008476%",
    fx: "49.9969402%",
    fy: "50.0008476%",
    r: "50.1604264%",
    gradientTransform: "translate(0.499969,0.500008),scale(1.000000,0.993496),translate(-0.499969,-0.500008)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    offset: "45%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F7F7",
    offset: "61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBECEB",
    offset: "73%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADCDB",
    offset: "82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C7C6",
    offset: "90%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9AEAC",
    offset: "97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BA19F",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-QUINIELAS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-10",
    transform: "translate(-326.000000, -702.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(326.000000, 702.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-medal",
    transform: "translate(1.350000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8457452,9.13304655 C10.534693,7.63608331 9.66452932,6.52959819 8.31624512,5.80341842 L8.31624512,5.80341842 C8.31624512,5.33390564 8.31559302,4.86582748 8.31428881,4.39918395 L6.116969,4.39918395 L6.11931657,4.39409756 L3.94821122,4.39135873 L3.92317054,4.39644512 C3.92317054,4.8659579 3.92317054,5.33468816 3.92317054,5.8026359 C3.46304801,6.04600002 3.03931273,6.3425756 2.68248302,6.72131591 C1.53178544,7.94283166 1.05131737,9.39049606 1.37997631,11.0337908 C1.77906218,13.0315677 3.00762062,14.3023823 4.97096656,14.8599287 C5.18498613,14.9209653 5.41191731,14.9150964 5.61967672,15 L6.58648178,15 C6.70816385,14.9479623 6.84040994,14.9577438 6.96678713,14.9330944 C8.06427326,14.7182923 8.99860369,14.208871 9.73221741,13.3614004 C10.7917512,12.1375371 11.1740129,10.7133483 10.8457452,9.13304655 Z",
    id: "Path",
    fill: "#F8AB30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.075353,10.3799942 C9.96814758,12.3362975 8.30294225,14.145878 6.11775152,14.1220111 L6.11775152,14.1220111 C3.95173257,14.1126208 2.11280751,12.3558605 2.16641022,10.0286422 C2.2141863,7.87901046 3.96798552,6.15993994 6.11814278,6.15516174 L6.11814278,6.15516174 C8.1851728,6.10155904 10.2095554,7.92600745 10.075353,10.3799942 Z",
    id: "Path",
    fill: "url(#radialGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94821122,4.39214126 L6.11931657,4.39488008 L6.116969,4.39996647 L8.31428881,4.39996647 C9.38816888,3.20844737 10.4624402,2.01718911 11.5371028,0.826191691 C11.7785106,0.559743189 12.0023117,0.278426781 12.2691515,0.0342801356 L12.2691515,0.00415306558 C10.9952068,0.00415306558 9.72113169,0.00284886342 8.44692617,0.000240459082 C8.35531292,-0.0033654427 8.26679558,0.0337316307 8.20512709,0.101576967 C7.54467911,0.766720073 6.87914475,1.42677679 6.22065308,2.0938762 C6.13301069,2.18269237 6.09192832,2.17604093 6.00780728,2.09074611 C5.345403,1.42090788 4.67752107,0.756938556 4.01237797,0.0890566266 C3.96072804,0.0314593831 3.88624465,-0.000339292648 3.80892243,0.00219676233 C2.57410382,0.00493558688 1.33889394,0.00376180493 0.104075333,0.00532684753 C0.0696443957,0.00532684753 0.0254319423,-0.0161924882 0,0.0291937472 C0.00369489334,0.0386323781 0.0085583539,0.0475706299 0.0144766441,0.0557994714 L3.92317054,4.39879269 L3.94821122,4.3937063",
    id: "Path",
    fill: "#E10600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6902903,9.29933233 C8.67268357,9.22812289 8.54943646,9.2727266 8.47587946,9.25120727 C8.44820947,9.24219915 8.41979788,9.2356527 8.3909759,9.23164424 C7.92576699,9.17256388 7.4613406,9.10683209 6.99887051,9.02857996 C6.95030917,9.02659366 6.90694797,8.99758547 6.8865787,8.95345791 C6.77585194,8.72104909 6.66669022,8.48785774 6.55126832,8.25818774 C6.40924071,7.97569755 6.28521108,7.68420837 6.11814278,7.41502104 C6.0982224,7.42732896 6.08723671,7.45006324 6.08997202,7.47331888 C6.043412,7.50657603 6.03010914,7.56135252 6.00702476,7.6083038 C5.79652653,8.03634295 5.584072,8.46359958 5.38100772,8.89476882 C5.34737912,8.98138628 5.26803235,9.04184096 5.17559588,9.05127308 C4.81602734,9.10213696 4.45606754,9.14791446 4.09767279,9.20386473 C3.90908515,9.23320928 3.71619365,9.2429908 3.5158682,9.30128863 C3.55968939,9.34823991 3.58981646,9.38580093 3.62502992,9.41866683 C4.00181393,9.75749855 4.35433977,10.122936 4.71390831,10.4782007 C4.76790228,10.5314121 4.81094095,10.5811022 4.79607305,10.6675708 C4.70490932,11.1867737 4.61804945,11.7071504 4.52884202,12.2267445 C4.52336438,12.2588279 4.49284604,12.2936501 4.5261032,12.3214296 C4.55936036,12.3492091 4.60005146,12.3194733 4.63291736,12.3022578 C5.12851418,12.0414174 5.62332848,11.7799249 6.11736026,11.5177802 C6.11736026,11.5267792 6.11736026,11.5361695 6.11931657,11.5451685 C6.1528454,11.5491938 6.18579841,11.557071 6.21752299,11.5686441 C6.50627335,11.7196707 6.79384993,11.8734361 7.08260029,12.024854 C7.29192473,12.134407 7.50281423,12.2416124 7.7148775,12.3503829 C7.72074641,12.3316024 7.7277891,12.3222121 7.72622406,12.3136044 C7.64249428,11.8276586 7.56345963,11.3409304 7.47112211,10.8565497 C7.43512613,10.6679621 7.44842899,10.5259345 7.60884586,10.3831243 C7.92772329,10.0978953 8.21412609,9.77706158 8.53495982,9.49222383 C8.59717026,9.43470851 8.70985333,9.37875824 8.6902903,9.29933233 Z",
    id: "Path",
    fill: "#F8AB30"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-362",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalla);
export default __webpack_public_path__ + "static/media/medalla.5adf799960d4b3e4542dcf4ac2190841.svg";
export { ForwardRef as ReactComponent };